<div class="h-full bg-(--comp-app-bg)">
  <div class="h-full">
    @if (isLoggedIn) {
      <div class="h-17 sticky top-0 z-1000">
        <app-header class="relative z-10"></app-header>
      </div>
    }

    <div
      class=""
      [class]="isLoggedIn ? 'lg:pt-2 lg:h-[calc(var(--height-full)-80px)]  ' : 'h-[100%] '"
    >
      <router-outlet class=""></router-outlet>
    </div>
  </div>
</div>
